import React, { memo } from 'react';
import { prefixedClasNames } from '../../utils/prefixedClassNames';
export var Component = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("button", { type: "button", className: prefixedClasNames('base-modal__close'), onClick: onClick }, "Close"));
};
export var CloseButton = memo(Component);
//# sourceMappingURL=CloseButton.js.map